import { render } from "./Button.vue?vue&type=template&id=14d40cfa&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=14d40cfa&lang=scss&scoped=true"
import "./Button.vue?vue&type=style&index=1&id=14d40cfa&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d40cfa"]])

export default __exports__